import { apiService } from '.';

export const asyncPostAgedmentWeCallYou = async (agendment: any) => {
    return await apiService.post(
        '/api/we-call-you-agenda/appointment',
        agendment
    );
};
export const asyncPostUpdateAgedmentWeCallYou = async (agendment: any) => {
    return await apiService.post(
        '/api/we-call-you-agenda/appointment/update-bp-record',
        agendment
    );
};
